import React from 'react'
import { CardInfo } from '../../../../../../Portfolio_R/SummaryCharts/components/CardInfo'

const CompositionLonCard = ({ t, mp }) => {
    return (
        <>
            <div className="composition">
                <div className="chart-row">
                    <h3 className="chart-title">{t('one_pager_report.composition')}</h3>
                    <div className="chart-content">
                        <CardInfo title={t('one_pager_report.projects')} data={mp.fields.projectTotalCount} />
                        <CardInfo title={t('one_pager_report.operations')} data={mp.fields.operationTotalCount} />
                        <CardInfo
                            title={t('one_pager_report.years')}
                            data={mp.fields.averageAge}
                            units={
                                (mp.fields.averageAge) > 1
                                    ? t('one_pager_report.antiquity_years')
                                    : t('one_pager_report.antiquity_year')
                            }
                            description={t('one_pager_report.no-warranties-included')}
                        />
                    </div>
                </div>
                <div className="chart-row">
                    <h3 className="chart-title">{t('one_pager_report.breakdown_operations')}</h3>
                    <div className="chart-content">
                        <CardInfo title={t('one_pager_report.guarantees')} data={mp.fields.guarantees} />
                        <CardInfo title={t('one_pager_report.investment')} data={mp.fields.investment} />
                        <CardInfo title="PBP" data={mp.fields.pbp} />
                    </div>
                </div>
            </div>
        </>
    )
}

export default CompositionLonCard